
import { Options, Vue } from 'vue-class-component';
import Header from '@/components/Header.vue';
import '@brslv/scroll-progress';

export default {
  components: { Header },
  methods: {
    isMobile() {
      if (screen.width <= 760) {
        return true;
      } else {
        return false;
      }
    },
  },
};
